import { createRootRoute } from '@tanstack/react-router';

import { notFoundPageLoadable } from 'pages/not-found-page';
import { RootPage } from 'pages/root-page';

export const rootRoute = createRootRoute({
  component: RootPage,
  notFoundComponent: notFoundPageLoadable,
});
